import { Component, Input } from '@angular/core';
import { SimpleBanner } from './models/simple-banner.interfaces';

@Component({
  selector: 'idp-simple-fast-action-banner',
  templateUrl: './simple-banner.component.html',
  styleUrls: ['./simple-banner.component.scss']
})
export class SimpleBannerComponent {
  @Input() content: SimpleBanner = {} as SimpleBanner;
}
